import { AppScope } from './appScope.types';

export type RouteScopeParams = {
  workspaceId?: string;
  teamId?: string;
};

/** Map route params + injected org → AppScope. Org never comes from params.app_id. */
export function appScopeFromRouteParams(
  params: RouteScopeParams,
  organizationId: string
): AppScope {
  if (params.teamId != null) {
    if (params.workspaceId == null) {
      throw new Error('team route requires workspaceId param');
    }
    return {
      level: 'team',
      organizationId,
      workspaceSlug: params.workspaceId,
      teamSlug: params.teamId
    };
  }
  if (params.workspaceId != null) {
    return {
      level: 'workspace',
      organizationId,
      workspaceSlug: params.workspaceId
    };
  }
  return { level: 'organization', organizationId };
}
